import React from 'react'

import { ErrorBoundary } from '@CommonComponents'

import { Header } from '@LTIDashboard/modules/SubmissionsDashboard/Header'
import { StudentsController } from '@LTIDashboard/modules/SubmissionsDashboard/Students'
import { useAssessmentsValue } from '@LTIDashboard/state'
import {
  LoadingSpinner,
  getLoadingSpinnerProps,
} from '@LTIDashboard/modules/common'

export function SubmissionsDashboard() {
  const { assessments, request } = useAssessmentsValue()
  const urlParams = window.location.pathname.split('/')
  const assessmentPK = urlParams[4]
  const assessment = assessments.find(item => item.pk === assessmentPK)
  const SubmissionsDashboardMap = {
    loading: { component: LoadingSpinner, props: getLoadingSpinnerProps() },
    validAssessment: {
      component: validAssessment,
      props: { assessment: assessment },
    },
    invalidAssessment: {
      component: invalidAssessment,
      props: { assessmentPK, courseNumber: urlParams[3] },
    },
  }
  let Component, props
  if (request === 'loading' || request === 'error') {
    const mapping = SubmissionsDashboardMap[request]
    Component = mapping.component
    props = mapping.props
  } else if (request === 'loaded' && !assessment) {
    const mapping = SubmissionsDashboardMap['invalidAssessment']
    Component = mapping.component
    props = mapping.props
  } else {
    const mapping = SubmissionsDashboardMap['validAssessment']
    Component = mapping.component
    props = mapping.props
  }

  return (
    <div className="card-myed">
      <ErrorBoundary resetKeys={[history.state]}>
        <Component {...props} />
      </ErrorBoundary>
    </div>
  )
}

function validAssessment({ assessment }) {
  console.log(assessment)
  return (
    <React.Fragment>
      <Header assessment={assessment} />
      <StudentsController submissions={assessment.submissions} />
    </React.Fragment>
  )
}

function invalidAssessment({ assessmentPK, courseNumber }) {
  return (
    <h3>
      No assesment with the PK {assessmentPK} is attached to course
      {courseNumber}
    </h3>
  )
}
